import * as api from '@/api'

export default {
  async getOneByAccessToken() {
    let result = {}

    try {
      result = await api.users.getOneByAccessToken()
    } catch (error) {
      console.error(error)
    }

    return result
  },

  async updateSectionRecords(payload) {
    let result = {}

    try {
      result = await api.users.updateSectionRecords(payload)
    } catch (error) {
      console.error(error)
    }

    return result
  },

  async updateQuizString(payload) {
    let result = {}

    try {
      result = await api.users.updateQuizString(payload)
    } catch (error) {
      console.error(error)
    }

    return result
  },

  async fetchHappyUsers(payload) {
    let result = {}

    try {
      result = await api.users.fetchHappyUsers(payload)
    } catch (error) {
      console.error(error)
    }

    return result
  }
}
